<template>
  <div class="log">
    <div class="lrow top">
      <h1 class="display-1 font-weight-thin mb-4">Loggable Logo</h1>
      <v-btn class="ma-2 login" outlined color="indigo">Login</v-btn>
    </div>
    <div class="lrow main">
      <div class="content">
        <h1 class="header-phrases">Your Projects.</h1>
        <!-- <h1 class="header-phrases">Your Clients.</h1>
        <h1 class="header-phrases">Your Invoices.</h1>-->
        <h1 class="header-phrases">Organized.</h1>
        <h1 class="header-phrases">Effortless.</h1>
        <h4 class="description">
          Manage your projects everywhere. Be it invoices, expenses or record your time spent on a
          project. Loggable is your personal assistant logging all the laborious stuff,
          leaving you to focus on doing the things that makes your business fly!
        </h4>
        <!-- <v-btn>Signup for free!</v-btn> -->
        <div class="my-2">
          <v-btn x-large color="success" dark>Signup for free!</v-btn>
        </div>
      </div>
      <div class="image">
        <img class="desktop-only image" src="@/assets/LoggableMacBook2.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../auth";
import { storeprops } from "../store/helpers.js";
import DialogLogin from "../components/dialogs/DialogLogin";
import DialogRegister from "../components/dialogs/DialogRegister";
import { signinWithEmailAndPassword, signinWithGoogle } from "../auth";

export default {
  components: {
    DialogLogin,
    DialogRegister,
  },
  data: () => ({
    showLoginForm: false,
    showRegisterForm: false,
    obj: null,
    error: "",
    value: [423, 446, 675, 510, 590, 610, 760],
    avg: 91,
  }),
  computed: {
    ...storeprops,
  },
  methods: {
    login() {
      //this.$router.push({ name: "login" });

      //signinWithGoogle(err => (this.error = err));

      // open the login dialog
      this.showLoginForm = true;
    },
    register() {
      this.showRegisterForm = true;
    },
    gotoRegister() {
      this.$router.push({ name: "register" });
    },
  },
  created() {
    this.obj = new objDataLogin();
    this.obj.closeDialog = () => {
      this.showLoginForm = false;
      this.showRegisterForm = false;
    };
    this.obj.showRegister = () => {
      this.showLoginForm = false;
      this.showRegisterForm = true;
    };
    this.obj.showLogin = () => {
      this.showLoginForm = true;
      this.showRegisterForm = false;
    };
  },
  mounted() {
    //debugger;
    // const { currentUser } = firebase.auth();
    // this.user = currentUser;
  },
};

class objDataLogin {
  loginWithEmailAndPassword = null;
  signinWithFacebook = null;
  signinWithGoogle = null;
  closeDialog = null;
}
</script>

<style lang="scss">
.v-parallax__content {
  color: black !important;
}
.v-parallax .v-parallax__image-container {
  opacity: 0.6 !important;
}
</style>

<style lang="scss" scoped>
.log {
  position: relative;
  max-width: 100%;

  .lrow {
    align-items: center;
    display: flex;
    margin: 0 auto;
    max-width: 1220px;
    margin: 0 auto;

    &.top {
      height: 80px;
      background: white;
      justify-content: space-between;
    }

    &.main {
      padding-top: 40px;
    }

    .content {
      color: #000;
      letter-spacing: 0;
      padding: 0px 40px 40px 0;
      position: relative;
      z-index: 1;
      width: 50%;

      .description {
        font-family: "Soleil_Light", Helvetica, Arial, sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 40px;
        margin-bottom: 35px;
      }
    }

    .image {
      width: 50%;
      text-align: center;

      img {
        height: auto;
        max-width: 100%;
        width: auto;
      }
    }
  }

  // &.top {
  //   max-width: 1220px;
  //   margin: 0 auto;
  //   align-items: center;
  //   display: flex;
  //   height: 80px;
  //   padding: 0;
  //   position: relative;
  //   &.login {
  //     display: inline-block;
  //     margin-left: auto;
  //   }
  // }
}

// .log-container .content {
//   color: #000;
//   letter-spacing: 0;
//   padding: 0 40px 40px 0;
//   position: relative;
//   z-index: 1;
//   width: 50%;

//   .description {
//     font-family: "Soleil_Light", Helvetica, Arial, sans-serif;
//     font-weight: normal;
//     font-size: 24px;
//     line-height: 40px;
//     margin-bottom: 35px;
//   }
// }

.header-phrases {
  font-family: "Soleil_Medium", Helvetica, Arial, sans-serif;
  font-size: 56px;
  font-weight: 700;
  line-height: 72px;
  margin-bottom: 2px;
  color: #000;
}
</style>